export const AI_TITLE_GENERATION_CREDIT_COST = 1;
export const AI_TITLE_AND_CATEGORY_CREDIT_COST = 2;
